import React, {Component} from 'react';

export default class FooterNav extends Component {
  render() {
    return(
      <footer className="py-5 bg-dark">
        <div className="container">
          <p className="m-0 text-center text-white">Copyright &copy; Gameopedia {(new Date().getFullYear())}</p>
        </div>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/FooterNav.jsx